export enum EAgrarianWorkingTimeHoursPeriod {
  START = 'START',
  END = 'END',
}
